<template>
  <ion-page style="overflow: auto;">
    <fis-header></fis-header>
    <div class="content visible-box">
      <div class="container-fluid" id="itenary-div">
        <div class="row">
          <div class="col-sm-12" id="top-margin"></div>
        </div>
        <div class="row">
          <div class="col-sm-1"></div>
          <div class="mt-5 ml-5">
            <bread-crumbs v-bind:crumbs="breadCrumbs"></bread-crumbs>
          </div>
          <div class="col-sm-1"></div>
        </div>
        <br><br>
        <div class="row">
          <div class="col-sm-1"></div>
          <div class="col-sm-7" id="sm-left-div">
            <div class="row">
              <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12" id="sponsors">
                <h2>{{ smcardData['name'] }}</h2>
              </div>
            </div>
            <div id="itenaryone" class="container-fluid" v-if="images.length == 1">
              <div class="row display-flex">
                <div class="col-12">
                  <img v-for="image in images" :key="image.id" :src="storageBaseUrl + '/' + image['image']">
                </div>
              </div>
            </div>

            <div id="itenarytwo" class="container-fluid" v-if="images.length == 2">
              <div class="row display-flex">
                <div class="col-6">
                  <img :src="storageBaseUrl + '/' + images[0]['image']">
                </div>
                <div class="col-6">
                  <img :src="storageBaseUrl + '/' + images[1]['image']">
                </div>
              </div>
            </div>

            <div id="itenarythree" class="container-fluid" v-if="images.length == 3">
              <div class="row display-flex">
                <div class="col-6" id="hero-img">
                  <img :src="storageBaseUrl + '/' + images[0]['image']" class="img-smcard">
                </div>
                <div class="col-6" id="other-imgs">
                  <img v-for="image in images.slice(1)" :key="image.id"
                       :src="storageBaseUrl + '/' + image['image']" class="img-smcard"
                       style="padding-bottom: 1px;">
                </div>
              </div>
            </div>

            <div id="itenaryfour" class="container-fluid" v-if="images.length == 4">
              <div class="row display-flex">
                <div class="col-6">
                  <img v-for="image in images.slice(0,2)" :key="image.id"
                       :src="storageBaseUrl + '/' + image['image']" class="img-fluid img-padding">
                </div>
                <div class="col-6">
                  <img v-for="image in images.slice(2,4)" :key="image.id"
                       :src="storageBaseUrl + '/' + image['image']" class="img-fluid img-padding">
                </div>
              </div>
            </div>

            <div id="itenary" class="container-fluid five-image-template" v-if="images.length == 5">
              <div class="row display-flex" id="itenary-row-5">
                <div class="col-6" id="hero-img-5">
                  <img :src="storageBaseUrl + '/' + images[0]['image']" class="hero-image-5">
                </div>
                <div class="col-6" id="other-images-container-5">
                  <div class="row" id="itenaryrow-5">
                    <div class="col-6" id="left-col-5">
                      <img v-for="image in images.slice(1,3)" :key="image.id"
                           :src="storageBaseUrl + '/' + image['image']" class="other-image-5">
                    </div>
                    <div class="col-6" id="right-col-5">
                      <img v-for="image in images.slice(3,5)" :key="image.id"
                           :src="storageBaseUrl + '/' + image['image']" class="other-image-5">
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div id="itenary-slider">
              <div class="carousel">
                <div class="carousel-inner">
                  <swiper :navigation="true"
                          :modules="modules" id="search-swipe">
                    <swiper-slide v-for="(image, imgIdx) in images" :key="image.id">
                      <img class="d-block"
                           :src="storageBaseUrl + '/' + image['image']"
                           :alt="smcardData['name'] || 'Photo'"
                           style="width: 100%"
                           v-bind="introCarouselImgAttrs(0, imgIdx)">
                    </swiper-slide>
                  </swiper>
                </div>
              </div>
            </div>

            <div id="itenary-bottom">
              <div class="col-sm-12">
                <div class="row">
                  <div class="col-sm-12 col-md-6 col-lg-6" id="itenary-desc">
                    <div class="icons">
                      <ul class="icons-list">
                        <li v-for="category in smcardData.categories" :key="category.id">
                          <img :src="storageBaseUrl + '/' + category.black_path" :alt="category.name" :title="category.name"
                               v-bind="lazyImageAttrs()">
                          <p>{{ category.name }}</p>
                        </li>
                      </ul>
                    </div>

                    <div class="capt" style="color:#bba756;font-weight: bold;font-size: 12px;">
                      <em>{{ smcardData.caption }}</em>
                    </div>

                    <div class="desc"><p>{{ smcardData.description }}</p></div>
                    <hr>

                    <div class="contact">
                      <template v-if="!shouldHidePhone(smcardData)">
                        <div class="numbers" v-if="smcardData.phone">
                          <p class="ph">{{ phoneLineLetter }}: {{ phone }}</p>
                        </div>
                        <br>
                        <p v-if="smcardData.mobile">M: {{ mobile }}</p>
                        <p v-if="smcardData.email">E: {{ smcardData.email }}</p>
                      </template>

                      <p>A: {{ smcardData.clean_address }} </p>
                      <p v-if="smcardData.website">W:
                        {{ smcardData.website.replace(/^(?:https?:\/\/)?(?:www\.)?/i, "").split('/')[0] }} </p>
                      <div id="social-div">
                        <ul class="social">
                          <li>
                            <a :href="smcardData.facebook || 'https://www.facebook.com/'" target="_blank" rel="noopener noreferrer" title="Facebook">
                              <span class="icon"><img
                                  src="/assets/images/fb-icon.png"
                                  style="width:32px;"/></span>
                            </a>
                            <p>Facebook</p>
                          </li>

                          <li>
                            <a :href="smcardData.instagram || 'https://www.instagram.com/'" target="_blank" rel="noopener noreferrer" title="Instagram">
                              <span class="icon"><img
                                  src="/assets/images/in-icon.png"
                                  style="width:32px;"/></span>
                            </a>
                            <p>Instagram</p>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div id="business-logo">
                      <img :src="storageBaseUrl + '/' + smcardData.logo" style="float:right; width: 60%;"
                           v-if="smcardData.logo">
                    </div>


                  </div>
                  <div class="col-sm-12 col-md-6 col-lg-6 p-0">
                    <div class="icons industry-icons">
                      <ul class="icons-list">
                        <li v-for="(symbol, index) in uniqueIndustrySymbols" :key="`symbol-${symbol.id}-${index}`">
                          <img :src="storageBaseUrl + '/' + symbol.icon_path" :alt="symbol.name">
                          <p>{{ symbol.name }}</p>
                        </li>
                      </ul>
                    </div>
                    <div class="row">
                      <div class="col-sm-12" id="map-smcard" v-if="smcardData.address">
                        <!-- Use embedded map directly since static API has key restrictions -->
                        <iframe
                            :src="mapEmbedUrl"
                            width="100%"
                            height="220"
                            style="border: 1px solid black; border-radius: 4px;"
                            allowfullscreen
                            loading="lazy"
                            referrerpolicy="no-referrer-when-downgrade"
                            @error="handleMapError">
                        </iframe>
                      </div>

                      <div class="col-sm-6 col-md-6 col-lg-6 text-center" id="amenities" v-if="smcardData.amenities">
                        <h2>Amenities</h2>
                        <p v-for="amenity in smcardData.amenities" :key="amenity.id">{{ amenity.name }}</p>
                      </div>
                      <div class="col-sm-6 col-md-6 col-lg-6  text-center" id="features" v-if="smcardData.facilities">
                        <h2>Facilities</h2>
                        <p v-for="facility in smcardData.facilities" :key="facility.id">{{ facility.name }}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-sm-12">
                <label>Lables: </label>
                <span v-for="label in smcardData.labels" :key="label.id"
                      class="badge badge-pill badge-primary" style="margin: 0px 5px;">{{ label.name }}</span>
              </div>
            </div>
          </div>
          <sponsors-page :total-sponsors="6" style="margin-top: 5px"></sponsors-page>
        </div>
      </div>
      <div class="container-fluid" id="mid-div">
        <div class="row">
          <div class="col-sm-2 col-lg-2"></div>
          <div class="col-sm-6 col-md-6 col-lg-6">
            <div class="row mt-5 ml-2">
              <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12" id="sponsors">
                <h2 id="members-heading">MEMBERS – ALL CATEGORIES SEARCH</h2>
              </div>
            </div>
            <div class="row search-intro-panel g-0" id="business-card" v-for="(introPanel, panelIndex) in introPanels" :key="introPanel.id">
              <div class="col-12 col-lg-4" id="card-img">
                <div class="carousel">
                  <div class="carousel-inner">
                    <swiper :navigation="introPanel['images'].length > 1"
                            :modules="modules" id="search-swipe">
                      <swiper-slide v-for="(images, slideIndex) in introPanel['images']" :key="images.id">
                        <img class="d-block"
                             :src="storageBaseUrl + '/' + images['image']"
                             :alt="introPanel.name || 'Member listing'"
                             style="width: 100%"
                             v-bind="introCarouselImgAttrs(panelIndex, slideIndex)">
                      </swiper-slide>
                    </swiper>
                  </div>
                </div>
              </div>
              <div class="col-12 col-lg-8" id="smart-search-text">

                <h2 style="text-transform: uppercase">
                  <a :href="'/smartcard/'+introPanel.id" target="_blank" rel="noopener noreferrer">{{ introPanel.name }}</a>
                </h2>
                <div class="category-icons-row">
                  <img v-for="category in introPanel.categories" :key="category.id"
                       :src="storageBaseUrl + '/' + category.black_path"
                       :alt="category.name"
                       :title="category.name"
                       v-bind="lazyImageAttrs()">
                </div>
                <p v-if="introPanel.caption" class="capt-line-caption"><em style="color:#bba756;">{{ introPanel.caption }}</em></p>
                <p v-if="introPanel.intro" class="capt-line-intro">{{ introPanel.intro }}</p>
                <p v-if="introPanel.clean_address" class="address-line"><b>A:</b> {{ introPanel.clean_address }}</p>
                <div class="intro-panel-contact-block" v-if="!shouldHidePhone(introPanel)">
                  <p class="ph"><b>{{ isAustralianMobile(introPanel.formatted_phone) ? 'M' : 'P' }}:</b> {{ introPanel.formatted_phone }}</p>
                  <p v-if="introPanel.formatted_mobile && String(introPanel.formatted_mobile).length > 6" class="mb">
                    <b>M:</b>{{ introPanel.formatted_mobile }}</p>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
      <fis-footer></fis-footer>
    </div>
  </ion-page>
</template>

<script lang="ts">
import {defineComponent} from "vue";
import fisHeader from "@/components/fisHeader.vue";
import fisFooter from "@/components/fisFooter.vue";
import axios from "@/axios";
import {IonPage} from "@ionic/vue";
import SponsorsPage from "@/components/sponsorsPage.vue";
import BreadCrumbs from "@/components/breadCrumbs.vue";
import {Swiper, SwiperSlide} from 'swiper/vue';
import {Navigation} from "swiper";
import { isAustralianMobile } from '@/utils/australianPhone';
import { introCarouselImgAttrs, lazyImageAttrs } from '@/utils/imageLoading';

import 'swiper/css';
import '@ionic/vue/css/ionic-swiper.css';
import "swiper/css/navigation";


export default defineComponent({
  name: "SmartCard",
  components: {Swiper, SwiperSlide, SponsorsPage, fisHeader, fisFooter, IonPage, BreadCrumbs},
  setup() {
    return {
      modules: [Navigation],
    };
  },
  computed: {
    mapImageUrl(): string {
      if (!this.smcardData || (!this.smcardData.lat && !this.smcardData.clean_address)) {
        return '';
      }
      const location = this.smcardData.lat
        ? `${this.smcardData.lat},${this.smcardData.lng}`
        : encodeURIComponent(this.smcardData.clean_address);
      const encoded = this.smcardData.lat ? location : location;
      return `https://maps.googleapis.com/maps/api/staticmap?center=${encoded}&zoom=14&size=600x350&sensor=false&markers=color:red%7C${encoded}&key=AIzaSyBjFt79J0tMTfSNyeKfVfigZUp10KObugY`;
    },
    mapEmbedUrl(): string {
      if (!this.smcardData || (!this.smcardData.lat && !this.smcardData.clean_address)) {
        return '';
      }
      const location = this.smcardData.lat
        ? `${this.smcardData.lat},${this.smcardData.lng}`
        : encodeURIComponent(this.smcardData.clean_address);
      return `https://www.google.com/maps?q=${location}&output=embed`;
    },
    uniqueIndustrySymbols(): Array<any> {
      if (!this.smcardData || !this.smcardData.industry_symbols) {
        return [];
      }
      // Remove duplicates based on id
      const seen = new Set();
      return this.smcardData.industry_symbols.filter((symbol: any) => {
        if (seen.has(symbol.id)) {
          return false;
        }
        seen.add(symbol.id);
        return true;
      });
    },
    phoneLineLetter(): string {
      return isAustralianMobile(this.phone) ? 'M' : 'P';
    }
  },
  methods: {
    introCarouselImgAttrs,
    lazyImageAttrs,
    isAustralianMobile,
    shouldHidePhone(card: any) {
      if (!card) return false;

      const clientId = Number(card.client_id ?? card.client?.id);
      if (clientId === 1) return true;

      const clientName = String(card.client?.business_name ?? '').toLowerCase();
      if (clientName.includes('find it smart') || clientName.includes('finditsmart')) return true;

      if (card.packages && card.packages.some((p: any) => {
        const packageId = Number(p.id ?? p.package_id ?? p.pivot?.package_id);
        const packageName = String(p.package_name ?? '').toLowerCase();
        return packageId === 48 || packageId === 49 || packageName.includes('fis free admin smartcard');
      })) return true;

      return false;
    },
    scheduleIdle(cb: () => void) {
      if (typeof window === 'undefined') {
        cb();
        return;
      }
      const ric = window.requestIdleCallback;
      if (typeof ric === 'function') {
        ric.call(window, cb, { timeout: 2000 });
      } else {
        window.setTimeout(cb, 0);
      }
    },
    async fetchData() {
      const response = await axios.get("/card-view/" + this.$route.params.id);
      this.country = response.data.country || ''
      this.state = response.data.state || ''
      this.region = response.data.region || ''
      this.shireCouncil = response.data.shireCouncil || ''
      this.shire = response.data.shireDirection || ''
      this.town = response.data.town || ''
      this.images = response.data.images
      this.smcardData = response.data.smcard
      this.phone = response.data.phoneFormatted
      this.mobile = response.data.mobileFormatted
      const introPanelsPayload = response.data.introPanels
      this.introPanels = []
      this.$nextTick(() => {
        this.scheduleIdle(() => {
          this.introPanels = introPanelsPayload
        })
      })
      const crumbParts = [this.country, this.state, this.region, this.shireCouncil, this.shire, this.town]
      this.breadCrumbs = crumbParts.filter(part => part && part.trim()).join(' > ')
      if(this.smcardData['address'] && this.smcardData['address'].indexOf('(') > 0) {
        this.smcardData['address'] = this.smcardData['address'].substring(0,this.smcardData['address'].indexOf('('));
      }
    },
    handleMapError(event: Event) {
      console.error('Map failed to load:', event);
      this.mapError = 'Map failed to load. Please check your connection.';
    },
  },
  created() {
    this.fetchData()
  },
  data() {
    return {
      storageBaseUrl: `${(process.env.VUE_APP_API_BASE_URL || '').replace(/\/+$/, '')}/storage`,
      town: '',
      breadCrumbs: '',
      country: '',
      state: '',
      region: '',
      shireCouncil: '',
      shire: '',
      smcardData: {},
      images: [] as Array<any>,
      phone: '',
      mobile: '',
      introPanels: [] as Array<any>,
      mapError: null as string | null,
    }
  }
});
</script>

<style>

/* === Unified image area: all layouts = 450px total height === */

#itenaryone,
#itenarytwo,
#itenarythree,
#itenaryfour,
#itenary {
  height: 450px;
  overflow: hidden;
  width: 100%;
  padding: 0;
  margin: 0;
}

/* 1 image */
#itenaryone .col-12 {
  padding: 1px;
  height: 450px;
}
#itenaryone img {
  width: 100%;
  height: 450px;
  object-fit: cover;
  display: block;
}

/* 2 images */
#itenarytwo .col-6 {
  padding: 1px;
  height: 450px;
}
#itenarytwo img {
  width: 100%;
  height: 450px;
  object-fit: cover;
  display: block;
}

/* 3 images: hero left (60%) + 2 stacked right (40%) */
#itenarythree #hero-img {
  height: 450px;
  width: 60%;
  padding: 0 1px;
}
#itenarythree #hero-img img {
  width: 100%;
  height: 450px;
  object-fit: cover;
  display: block;
}
#itenarythree #other-imgs {
  height: 450px;
  width: 40%;
  max-width: 40%;
  padding: 0 1px;
  display: flex;
  flex-direction: column;
}
#itenarythree #other-imgs img {
  width: 100%;
  height: calc(50% - 1px);
  object-fit: cover;
  display: block;
  flex: 1;
}
#itenarythree #other-imgs img:first-child {
  margin-bottom: 2px;
}

/* 4 images: 2×2 grid (each cell = 225px) */
#itenaryfour .col-6 {
  padding: 1px;
  height: 450px;
  display: flex;
  flex-direction: column;
}
#itenaryfour img {
  width: 100%;
  height: calc(50% - 1px);
  object-fit: cover;
  display: block;
  flex: 1;
}
#itenaryfour img:first-child {
  margin-bottom: 2px;
}

.row.display-flex {
  display: flex;
  flex-wrap: nowrap;
  margin: 0;
  width: 100%;
}

.row.display-flex > [class*='col-'] {
  display: flex;
  flex-direction: column;
}

.img-padding {
  padding: 1px;
}

.img-smcard {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

/* 5-image layout - matching heights */
#itenary {
  height: 450px;
  padding: 0;
}

#itenary.five-image-template {
  padding-right: 0 !important;
}

#itenary-row-5 {
  height: 100%;
  margin: 0;
  display: flex;
  align-items: stretch;
}

#itenary #hero-img-5 {
  height: 100%;
  width: 50%;
  max-width: 50%;
  flex: 0 0 50%;
  padding: 0 1px;
  display: flex;
  align-items: stretch;
}

#itenary .hero-image-5 {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

#itenary #other-images-container-5 {
  height: 100%;
  width: 50%;
  max-width: 50%;
  flex: 0 0 50%;
  padding: 0;
  display: flex;
  align-items: stretch;
}

#itenaryrow-5 {
  height: 100%;
  width: 100%;
  margin: 0;
  display: flex;
  align-items: stretch;
}

#itenary #left-col-5,
#itenary #right-col-5 {
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 1px;
  width: 50%;
  margin: 0;
}

#itenary .other-image-5 {
  width: 100%;
  height: calc(50% - 2px);
  object-fit: cover;
  flex-shrink: 0;
  display: block;
  margin-bottom: 1px;
}

#itenary .other-image-5:last-child {
  margin-bottom: 0;
}

/* Description text */
#itenary-desc .desc {
  font-size: 1.0em;
  line-height: 22px;
  margin-bottom: 4px;
}

#itenary-desc hr {
  margin-top: 4px;
  margin-bottom: 4px;
}

#itenary-desc .contact {
  margin-top: 4px;
  font-weight: 700;
  font-size: 0.95em;
}

#itenary-desc .contact p,
#itenary-desc .contact .ph {
  font-weight: 700;
}

/* Members section heading */
#members-heading {
  font-weight: 900;
  font-size: 1.2rem;
  letter-spacing: 0.04em;
  color: #231f20;
}

/* #sponsors h2 font-weight/text-decoration set globally in app.css */

#mid-div #business-card h2 {
  text-decoration: underline;
  text-underline-offset: 0.12em;
}

#mid-div .search-intro-panel #smart-search-text h2 a {
  text-decoration: underline;
  text-underline-offset: 0.12em;
  color: #34aade !important;
}

#mid-div .search-intro-panel #smart-search-text h2 {
  color: #34aade;
}

/* Text block spacing */
#mid-div .search-intro-panel #smart-search-text h2 {
  margin-bottom: 0.75rem;
}

#mid-div .search-intro-panel #smart-search-text .category-icons-row {
  margin-bottom: 0.75rem;
}

#mid-div .search-intro-panel #smart-search-text .capt-line-caption,
#mid-div .search-intro-panel #smart-search-text .capt-line-intro {
  margin-bottom: 0.75rem;
}

#mid-div .search-intro-panel #smart-search-text .capt-line-caption em {
  font-weight: 900;
  font-style: italic;
}

#mid-div .search-intro-panel #smart-search-text .capt-line-intro {
  font-size: 0.8rem;
}

#mid-div .search-intro-panel #smart-search-text > p {
  margin-bottom: 0.75rem;
}

#mid-div .search-intro-panel #smart-search-text .address-line {
  margin-bottom: 0.25rem;
}

#mid-div .search-intro-panel .intro-panel-contact-block {
  max-width: 230px;
  width: 100%;
  margin-top: 0;
}

/* Category icons row */
#mid-div .search-intro-panel #smart-search-text .category-icons-row {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 4px;
}

#mid-div .search-intro-panel #smart-search-text .category-icons-row img {
  position: static !important;
  display: inline-block;
  vertical-align: middle;
  width: 21px !important;
  height: auto !important;
  right: auto !important;
  bottom: auto !important;
  padding: 0 !important;
  margin: 0 !important;
}

/* MEMBERS intro panels: stack on small screens; override app.css fixed heights */
#mid-div .search-intro-panel#business-card {
  height: auto !important;
  min-height: 0;
  align-items: stretch;
}

#mid-div .search-intro-panel #smart-search-text {
  overflow-wrap: anywhere;
  word-break: break-word;
}

@media (min-width: 992px) {
  #mid-div .search-intro-panel#business-card #card-img,
  #mid-div .search-intro-panel#business-card #smart-search-text {
    min-height: 250px;
  }

  #mid-div .search-intro-panel #card-img,
  #mid-div .search-intro-panel #card-img .carousel,
  #mid-div .search-intro-panel #card-img .carousel-inner,
  #mid-div .search-intro-panel #card-img .swiper,
  #mid-div .search-intro-panel #card-img .swiper-wrapper,
  #mid-div .search-intro-panel #card-img .swiper-slide {
    height: 250px !important;
  }

  #mid-div .search-intro-panel .d-block {
    height: 250px !important;
    width: 100%;
    object-fit: cover;
  }
}

@media (max-width: 991.98px) {
  #mid-div .search-intro-panel#business-card,
  #mid-div .search-intro-panel#business-card #card-img,
  #mid-div .search-intro-panel#business-card #smart-search-text {
    height: auto !important;
    min-height: 0 !important;
    max-height: none !important;
  }

  #mid-div .search-intro-panel #card-img .carousel-inner {
    border-radius: 15px 15px 0 0;
  }

  #mid-div .search-intro-panel #smart-search-text {
    border-radius: 0 0 15px 15px;
    padding-left: 3%;
    padding-right: 3%;
    padding-bottom: 0.75rem;
  }

  #mid-div .search-intro-panel #card-img .swiper,
  #mid-div .search-intro-panel #card-img .swiper-wrapper,
  #mid-div .search-intro-panel #card-img .swiper-slide {
    height: clamp(220px, 55vw, 340px) !important;
  }

  #mid-div .search-intro-panel .d-block {
    height: 100% !important;
    min-height: 200px !important;
    width: 100%;
    object-fit: cover;
  }
}

</style>
